import { MantineTheme } from "@mantine/core";
import { createStyles } from "@mantine/emotion";

import AuthBackground from "../../assets/authBackground.jpg";

export const useStyles = createStyles((_theme: MantineTheme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    minHeight: "100vh",
    background: "#FFFFFF",
  },

  // Opt-in only (the `brandBackground` prop) — this layout backs ~10 screens
  // across investor and admin, so the pale illustration is applied per page
  // rather than to all of them. `cover` + centre keeps the tree behind the
  // content at every aspect ratio; the flat colour underneath is sampled from
  // the artwork's own edge so a tall viewport never shows a white seam.
  brandBackground: {
    backgroundColor: "#eef4f4",
    backgroundImage: `url(${AuthBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },

  iconContainer: {
    position: "absolute",
    top: "58px",
    left: "85px",
    width: "151px",
    zIndex: 2,
  },
  leftContainer: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    padding: "0 2rem",
  },
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "40px",
    padding: "13px 87px",
  },
  stepContent: {
    display: "flex",
    flexDirection: "column",
    gap: "25px",
    paddingBottom: "30px",
  },
  backImage: {
    display: "flex",
    width: "full",
  },
  logo: {
    width: 170,
    marginTop: 56,
    marginLeft: 0,
  },
}));
